import { Form } from "react-bootstrap";
import { FieldError, RegisterOptions, UseFormRegister } from "react-hook-form";
import stylesInput from "../../../assets/styles/inputs.module.css";

interface EventModalInputProps {
    name: string;
    label: string;
    register: UseFormRegister<any>;
    registerOptions?: RegisterOptions;
    error?: FieldError;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

const EventModalInput = ({
    name,
    label,
    register,
    registerOptions,
    error,
    value,
    onChange,
    placeholder,
    className,
}: EventModalInputProps) => {
    const { onChange: registerOnChange, ...registerRest } = register(name, registerOptions);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
        registerOnChange(e);
    };

    return (
        <Form.Group className={`mb-3 ${stylesInput.formGroup}`} controlId={name + "-input"}>
            <Form.Label className={stylesInput.label}>{label}</Form.Label>
            <div className={stylesInput.inputWrapper}>
                <Form.Control
                    {...registerRest}
                    onChange={handleChange}
                    value={value}
                    placeholder={placeholder}
                    className={className}
                />
            </div>
            {error && (
                <Form.Text className="text-danger">
                    {error.message}
                </Form.Text>
            )}
        </Form.Group>
    );
};

export default EventModalInput;
